import React from "react"
import { useHistory } from "react-router-dom"
import { view } from "@risingstack/react-easy-state"

import * as AuthHelper from "helpers/auth.helper"
import * as URLHelper from "helpers/url.helper"
import ContentLoading from "components/common/ContentLoading"

const LogoutPage = () => {
  const history = useHistory()
  AuthHelper.logout()

  const referrer = document.referrer

  if (URLHelper.isSecureSubDomain(window.location.href)) {
    if (!referrer) {
      history.replace("/login")
      return
    }

    if (URLHelper.isSecureSubDomain(referrer)) {
      history.replace("/login")
      return
    }

    const parsedReferrer = URLHelper.getParsedUrl(referrer)

    window.location = parsedReferrer.origin
    return
  }

  window.location = URLHelper.getSecureURL("/logout")

  return <ContentLoading />
}

export default view(LogoutPage)
